<mat-nav-list>
  <mat-list-item routerLinkActive="activo" [routerLink]="['/cliente/gestion']">
    <img src="../../../../assets/apreton-de-manos-1.svg" />
    Gestión Contratistas
  </mat-list-item>
  <mat-list-item routerLinkActive="activo" [routerLink]="['estado']">
    <img src="../../../../assets/estados.svg" />
    Entidades/ Estado
  </mat-list-item>
  <mat-list-item
   *ngIf="!xtensaBasica"
    routerLinkActive="activo"
    [routerLink]="['/cliente/zonasgrupos']"
  >
    <img src="../../../../assets/forma-1.svg" />
    Gestión Zonas y Grupos
  </mat-list-item>
</mat-nav-list>
